import { Controller, FieldValues, useFormState } from 'react-hook-form';
import { Textarea } from '@heroui/react';
import { FormTextareaProps } from './types';

const FormTextarea = <TFieldValues extends FieldValues = FieldValues>({
  name,
  control,
  label,
  placeholder,
  isRequired = false,
  isDisabled = false,
  description,
  className,
  showErrorOnTouched = true,
  ...rest
}: FormTextareaProps<TFieldValues>) => {
  const { touchedFields, errors, isSubmitted } = useFormState({ control });
  const fieldError = errors[name]?.message as string | undefined;
  const isTouched = touchedFields[name];
  const showError = showErrorOnTouched ? (isTouched || isSubmitted) && !!fieldError : !!fieldError;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Textarea
          {...field}
          {...rest}
          label={label}
          placeholder={placeholder}
          isRequired={isRequired}
          isDisabled={isDisabled}
          description={description}
          className={className}
          isInvalid={showError}
          errorMessage={showError ? fieldError : undefined}
        />
      )}
    />
  );
};

FormTextarea.displayName = 'FormTextarea';

export default FormTextarea;
